import { useTranslation } from 'react-i18next'
import isEmpty from 'lodash-es/isEmpty'

import { useTimeZone } from '../../../../hooks'
import { ListItem } from '../../../ListItem'
import { Widget, WidgetContentItemsList } from '../../../Widget'
import { useEmailProfileContext } from '../../Email.hooks'

import { QA_NAME_EMAIL_PROFILE_WIDGET_APPOINTMENTS } from './EmailProfileWidgetAppointments.constants'
import { getEmailProfileWidgetAppointmentItemProps } from './EmailProfileWidgetAppointments.utils'

// TODO: a row opens the appointment's preview in place, not the calendar, once TM-02-31 builds it
function EmailProfileWidgetAppointments({
  initiallyExpanded,
  isSkeleton,
  widgetProps,
}) {
  const { t } = useTranslation()

  const timezone = useTimeZone()

  const { appointments } = useEmailProfileContext()

  function getItemProps(appointment) {
    return getEmailProfileWidgetAppointmentItemProps({
      appointment,
      t,
      timezone,
    })
  }

  return isEmpty(appointments) ? null : (
    <Widget
      {...widgetProps}
      headerProps={{
        contentProps: {
          actionsProps: {
            EditButton: null,
          },
        },
      }}
      initiallyExpanded={initiallyExpanded}
      isSkeleton={isSkeleton}
      qaName={QA_NAME_EMAIL_PROFILE_WIDGET_APPOINTMENTS}
      title={t('Appointment.WidgetTitleKey')}
    >
      <WidgetContentItemsList
        Item={ListItem}
        getItemPropsFromValue={getItemProps}
        items={appointments}
      />
    </Widget>
  )
}

export default EmailProfileWidgetAppointments
